import { render, staticRenderFns } from "./pagefra.vue?vue&type=template&id=daeb5e5a"
import script from "./pagefra.vue?vue&type=script&lang=js"
export * from "./pagefra.vue?vue&type=script&lang=js"
import style0 from "./pagefra.vue?vue&type=style&index=0&id=daeb5e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports